<template>
  <h1>{{ titleComputed }}</h1>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import unCapitalize from '@/helpers/unCapitalize'

  export default {
    name: 'VacanciesResultTitle',
    computed: {
      ...mapState('vacancies', [
        'title',
        'profession',
        'country',
        'city',
      ]),
      ...mapGetters('vacancies', [
        'dynamicFiltersItems',
      ]),
      titleComputed() {
        if(this.title) {
          return this.title
        }

        const professionName = this.professionName
        let params = [...this.dynamicFiltersItemsFormat]

        if (this.country) {
          params.push(`${this.$tFilter('Country')}: ${this.country.name}`)
        }

        if (this.city) {
          params.push(`${this.$tFilter('City')}: ${this.city.name}`)
        }

        params = params.join(', ')

        if (params && professionName) {
          return professionName + ' ' + params
        }

        if (params) {
          return this.$tVacancies('Vacancies') + ' ' + params
        }

        if (professionName) {
          return professionName
        }

        return this.$tVacancies('Vacancies')
      },
      professionName() {
        const profession = this.profession
        return profession ? profession.category.title : null
      },
      dynamicFiltersItemsFormat() {
        return this.dynamicFiltersItems.map(item => {
          return unCapitalize(item.title)
        })
      },
    }
  }
</script>

<style lang="less">

</style>
